import axios from "axios";
import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PdfReportButton({ month }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const download = async () => {
    setBusy(true); setError("");
    try {
      const res = await axios.get(`${API}/reports/monthly-pdf?month=${month}`, { responseType: "blob" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(res.data);
      link.download = `kar-zarar-${month}.pdf`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch {
      setError("PDF oluşturulamadı");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="pdf-action">
      <button className="outline-btn" data-testid="download-pdf-button" onClick={download} disabled={busy}>
        {busy ? <Loader2 size={16} className="spin"/> : <FileDown size={16}/>} PDF Rapor
      </button>
      {error && <small className="error-text" data-testid="pdf-error">{error}</small>}
    </div>
  );
}
